import type { SxProps, Theme } from '@mui/material/styles';

const compareVersionsModalStyles = {
  header: {
    p: 2,
    borderBottom: 1,
    borderColor: 'divider'
  },
  content: {
    p: 2,
    height: '80vh',
    overflowY: 'auto'
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh'
  },
  footer: {
    p: 2,
    display: 'flex',
    justifyContent: 'flex-end'
  }
} as const satisfies Record<string, SxProps<Theme>>;

export default compareVersionsModalStyles;
